export default "__VITE_ASSET__DlG0_A3L__"